export default __webpack_public_path__ + "0cf9ed8e80b222119fe3dcbad477a783.jpg";